module.exports = __webpack_public_path__ + "img/partner_15.7d30bf87.png";